import { GlFilteredSearchSuggestion } from '../../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { createAlert } from '../../../../alert.js?vue3';
import { __ } from '~/locale';
import { NAMESPACE_GROUP, NAMESPACE_PROJECT } from '~/issues/constants';
import { sortMilestonesByDueDate } from '~/milestones/utils';
import BaseToken from './base_token.vue?vue3';
import { stripQuotes } from '~/lib/utils/text_utility';
import { glListenersMixin } from '~/lib/utils/vue3compat/gl_listeners_mixin';
import { DEFAULT_MILESTONES } from '../constants';
import searchMilestonesQuery from '../queries/search_milestones.query.graphql';
export default {
    name: 'MilestoneToken',
    components: {
        BaseToken,
        GlFilteredSearchSuggestion
    },
    mixins: [
        glListenersMixin
    ],
    props: {
        active: {
            type: Boolean,
            required: true
        },
        config: {
            type: Object,
            required: true
        },
        value: {
            type: Object,
            required: true
        }
    },
    data () {
        return {
            milestones: this.config.initialMilestones || [],
            loading: false
        };
    },
    computed: {
        defaultMilestones () {
            return this.config.defaultMilestones || DEFAULT_MILESTONES;
        },
        namespace () {
            return this.config.isProject ? NAMESPACE_PROJECT : NAMESPACE_GROUP;
        },
        fetchMilestonesQuery () {
            return this.config.fetchMilestones ? this.config.fetchMilestones : this.fetchMilestonesBySearchTerm;
        }
    },
    methods: {
        getActiveMilestone (milestones, data) {
            /* We need to check default milestones against the value not the
       * title because there is a discrepancy between the value graphql
       * accepts and the title.
       * https://gitlab.com/gitlab-org/gitlab/-/issues/337687#note_648058797
       */ return milestones.find((milestone)=>this.getMilestoneTitle(milestone).toLowerCase() === stripQuotes(data).toLowerCase()) || this.defaultMilestones.find(({ value })=>value === data);
        },
        getMilestoneTitle (milestone) {
            return milestone.title;
        },
        fetchMilestonesBySearchTerm (search) {
            return this.$apollo.query({
                query: searchMilestonesQuery,
                variables: {
                    fullPath: this.config.fullPath,
                    search,
                    isProject: this.config.isProject
                }
            }).then(({ data })=>data[this.namespace]?.milestones.nodes);
        },
        fetchMilestones (searchTerm) {
            this.loading = true;
            this.fetchMilestonesQuery(searchTerm).then((response)=>{
                const data = Array.isArray(response) ? response : response.data;
                const uniqueData = data.reduce((acc, current)=>{
                    const existingItem = acc.find((item)=>item.title === current.title);
                    if (!existingItem) {
                        acc.push(current);
                    }
                    return acc;
                }, []);
                if (this.config.shouldSkipSort) {
                    this.milestones = uniqueData;
                } else {
                    this.milestones = uniqueData.slice().sort(sortMilestonesByDueDate);
                }
            }).catch(()=>{
                createAlert({
                    message: __('There was a problem fetching milestones.')
                });
            }).finally(()=>{
                this.loading = false;
            });
        }
    }
};
